import { Title, Tooltip } from "@mantine/core"
import {
  createMRTColumnHelper,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table"
import { useMemo } from "react"

import { LabelsExplorerValues } from "@costory/types/endpoints/labelsExplorer"

import { CustomCopyCellButton } from "@costory/front/components/common/CustomCopyCellButtton"
import { NumberCell } from "@costory/front/components/table/NumberCell"
import { truncateLabel } from "@costory/front/utils/charts"
import { getDefaultTableOptions } from "@costory/front/utils/table"

export const TopValuesTable = ({
  values,
}: {
  values: LabelsExplorerValues[]
}) => {
  const columns = useMemo(() => {
    const columnHelper = createMRTColumnHelper<LabelsExplorerValues>()
    return [
      columnHelper.accessor("value", {
        header: "Values",
        Cell: ({ cell }) => {
          const name = cell.getValue()
          const truncated = truncateLabel(name, 25)
          return (
            <Tooltip
              style={{ wordBreak: "break-all" }}
              label={name}
              multiline
              maw={350}
              position="top"
            >
              <span>{truncated}</span>
            </Tooltip>
          )
        },
      }),

      columnHelper.accessor("cost_allocated", {
        header: "Cost",
        Cell: ({ cell }) => (
          <CustomCopyCellButton cell={cell}>
            <NumberCell
              value={+cell.getValue()! || 0}
              disableColor={true}
              currency="USD"
            />
          </CustomCopyCellButton>
        ),
      }),
      columnHelper.accessor("proportion_cost_allocated", {
        header: "% of Label",
        Cell: ({ cell }) => (
          <CustomCopyCellButton cell={cell}>
            <NumberCell
              value={+cell.getValue()! || 0}
              numberType="percent"
              disableColor={true}
              currency="USD"
            />
          </CustomCopyCellButton>
        ),
      }),
    ]
  }, [])
  const table = useMantineReactTable<LabelsExplorerValues>({
    columns,
    data: values,
    initialState: { pagination: { pageIndex: 0, pageSize: 5 }, density: "xs" },
    ...getDefaultTableOptions(true),
    renderTopToolbarCustomActions: () => (
      <Title order={4}>Top Values (Past 30 Days)</Title>
    ),
    mantinePaperProps: {
      style: {
        border: "none",
      },
    },
  })
  return <MantineReactTable table={table} />
}
